import styled from "styled-components"
import { breakpoints } from "@config/theme"
import { TitleS, LabelS } from "@components/Typography"

export const ImgWrapper = styled.div`
  flex: 0 0 22%;
  margin-right: 1rem;

  img {
    max-width: 100%;
  }

  @media (max-width: ${breakpoints.small}) {
    flex: 0 0 20%;
  }
`

export const Title = styled(TitleS)`
  font-size: 1.25rem;
  margin: 0;
  padding-bottom: 0.5rem;
  text-decoration: none;
  color: #000;
  font-family: ${(p) => p.theme.fonts.serif};
  @media (max-width: ${breakpoints.small}) {
    font-size: 1rem;
  }
`

export const Price = styled(LabelS)`
  margin-bottom: 0;
`

export const Anchor = styled.div`
  display: flex;
  width: 100%;
  cursor: pointer;
  padding-top: 1rem;

  @media (max-width: ${breakpoints.medium}) {
    padding-top: 0.5rem;
  }
`

export const InfoWrapper = styled.div`
  flex: 0 0 88%;

  @media (max-width: ${breakpoints.small}) {
    flex: 0 0 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`

export const ActionWrapper = styled.div`
  display: flex;
  align-items: center;

  button {
    font-size: 14px;

    svg {
      margin-left: 0;
    }
  }

  @media (max-width: ${breakpoints.small}) {
    display: none;
  }
`

export const Dot = styled.div`
  display: block;
  content: "";
  height: 0.5rem;
  width: 0.5rem;
  border-radius: 100%;
  margin: 0 1rem;
  background-color: ${(p) => p.theme.colors.purple};
`

export const AddToBag = styled.div<{ isLoading: boolean }>`
  display: flex;

  svg {
    width: 1rem;
    height: 1rem;
    margin-right: 0.5rem;
  }

  ${(p) =>
    p.isLoading &&
    `
    opacity: 0.5;
    pointer-events: none;
  `}
`
